function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" {...props}><defs /><g id="square" className={styles["cls-1"] || "cls-1"} strokeWidth="2"><rect width="35" height="35" className={styles["cls-2"] || "cls-2"} rx="1" /><rect width="32.7" height="32.7" x="1.15" y="1.15" className={styles["cls-3"] || "cls-3"} rx=".15" /></g></svg>;
});